/** @format */

import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { reportService } from "../../../Services/report.service";
import { globalServices } from "../../../Services/global.service";
import { storeService } from "../../../Services/store.service";
import SpinnerLoading from "../../Common/SpinnerLoading";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { useTranslation } from "react-i18next";
import iconcontentcalendar from "../../../Images/Icons/iconcontentcalendar.png";
import { useForm, Controller } from "react-hook-form";
import { Modal } from "react-bootstrap";
import Tooltip from "../../../Components/Common/Tooltip";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import Select from "react-select";
import { AuthContext } from "../../../Contexts/AuthContext";
import { invoiceListServices } from "../../../Services/PDFservice/invoicelist.service";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import AsyncSelect from "react-select/async";
import XLSX from "xlsx";
import { convertToPdf } from "../../../Services/PDFservice/invoiceToPdf.service";
import QRCode from "qrcode.react";
import { convertToDecimalString, convertToDecimalForPoreznaString } from "../../../Helpers/DecimalNumberHelper";
import { activeCurrencyByDate } from "../../../Helpers/CurrencyConverter";
import { tr } from "date-fns/locale";

pdfMake.vfs = pdfFonts.pdfMake?.vfs;
registerLocale("hr", hr);
registerLocale("en", en);

const Table = () => {
  const {
    updateLocName,
    updateLocPos,
    updateLocTenant,
    updateLocStore,
    updateLocTab,
    selectedLanguageId,
    isMobile,
    locTenant,
  } = useContext(GlobalContext);
  const { t: translator } = useTranslation();
  const { handleSubmit, errors, control, setValue } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
  });
  const { userId, roleId, tenantId, tenantName } = useContext(AuthContext);
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [storesTag, setStoresTag] = useState([]);
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [invoiceDetailsItems, setInvoiceDetailsItems] = useState([]);
  const [invoiceDetailsTaxes, setInvoiceDetailsTaxes] = useState([]);
  const [invoiceDetailsPayments, setInvoiceDetailsPayments] = useState([]);
  const [qrcodeText, setQRcodeText] = useState("");
  const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [posTag, setPosTag] = useState([]);
  const [update, setUpdate] = useState(new Date());
  const [search, setSearch] = useState({
    tenantId:
      Number(localStorage.getItem("tenantId")) > 0
        ? Number(localStorage.getItem("tenantId"))
        : 0,
    posId: 0,
    from: "",
    to: "",
    pageIndex: 0,
    pageSize: 10,
    searchText: "",
  });

  const [reportTag, setReportTag] = useState({
    tenantName: "",
    storeName: "",
    posName: "",
    date: "",
  });

  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });

  let reportId = [];
  const [tenantObj, setTenantObj] = useState({
    id: 0,
    label: translator("Select-Tenant"),
    value: translator("Select-Tenant"),
  });
  useEffect(() => {
    updateLocName("invoices-invoiceslist");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
  });

  useEffect(() => {
    if (reportTag.date != "") {
      handleToSearch();
    }
  }, [update]);

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant)
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.name,
        }));

        return result;
      })
      .catch((err) => err);
  };

  const getStores = (tenant) => {
    globalServices
      .getStoresByTenantId(tenant)
      .then((res) => {
        setStoresTag(res.data);
      })
      .catch((err) => console.log(err));
  };

  const getPos = (store) => {
    storeService
      .getPosByStoreId(store)
      .then((res) => {
        setPosTag(res.data);
      })
      .catch((err) => console.log(err));
  };

  const handleToSearch = (event) => {
    let pageI = pagination.pageIndex;

    if (event) {
      pageI = 0;
    }

    setIsLoading(true);
    var m = moment();
    var date = moment(startDate);
    m.set(date.toObject());
    console.log("end",m.endOf("month").startOf("day").format());

    reportService
      .invoicesList({
        tenantId:
          localStorage.getItem("tenantId") === "null"
            ? Number(search.tenantId)
            : Number(localStorage.getItem("tenantId")),
        posId: search.posId,
        from: m.startOf("month").format(),
        to: m.endOf("month").startOf("day").format(),
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      })
      .then((res) => {
        setReports(res.data.data);
        setPagination({
          ...pagination,
          totalCount: res.data.totalCount,
          pageIndex: pageI,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const getDetails = (invoiceGuid) => {
    reportService
      .invoiceDetail(invoiceGuid)
      .then((res) => {
        setInvoiceDetails(res.data.data);
        setInvoiceDetailsItems(res.data.items);
        setInvoiceDetailsTaxes(res.data.taxes);
        setInvoiceDetailsPayments(res.data.payments);
        setQRcodeText(
          `https://porezna.gov.hr/rn?jir=${res.data.data.jir}&datv=${new Date(
            res.data.data.issued
          )
            .toISOString()
            .replace("-", "")
            .split("T")[0]
            .replace("-", "")}_${new Date(
              res.data.data.issued
            ).getHours().toString().padStart(2, '0')}${new Date(
              res.data.data.issued
            ).getMinutes().toString().padStart(2, '0')}&izn=${convertToDecimalForPoreznaString(
              res.data.data.payValue
            ).replace(".", "")}`
        );
      })
      .catch((err) => console.log(err));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setSearch({ ...search, [name]: value });
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });

    setUpdate(new Date());
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      setShowInvoiceDetails(true);
      getDetails(row.invoiceGuid);
    },
  };

  const rowClasses = (row, rowIndex) => {
    if (row.payValue === 0) {
      return "text-danger";
    } else {
      return "boostrap-table-row";
    }
  };

  const RemoteAll = ({ data, page, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="reportId"
        data={data}
        columns={columns}
        rowEvents={rowEvents}
        noDataIndication={translator("No-Data")}
        rowClasses={rowClasses}
        pagination={paginationFactory({
          page,
          hideSizePerPage: true,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  function currencyFormatter(cell, row) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: activeCurrencyByDate(row?.issued),
    }).format(Number(cell));
  }
  function documentNumberFormatter(cell, row) {
    return `${cell}/${row.storeTag}/${row.posTag}`;
  }

  function dateTimeFormatter(cell, row) {
    return new Intl.DateTimeFormat("hr", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
      timeZone: "Europe/Zagreb",
    }).format(new Date(cell));
  }
  function fiscalFormatter(cell, row) {
    return cell ? "Da" : "Ne";//${cell *}/${row.storeTag}/${row.posTag}`;
  }
  const columns = [
    {
      dataField: "documentNumber",
      text: translator("Report-View-TableHeader-DocumentNumber"),
      formatter: documentNumberFormatter,

      headerStyle: () => {
        return { width: "300px" };
      },
      style: () => {
        return { width: "300px" };
      },
    },
    {
      dataField: "issued",
      text: translator("Report-View-TableHeader-Issued"),
      formatter: dateTimeFormatter,
      hidden: Boolean(isMobile),
    },

    {
      dataField: "payValue",
      text: translator("Report-View-TableHeader-PayValue"),
      formatter: currencyFormatter,
      headerStyle: () => {
        return { width: "400px", textAlign: "right" };
      },
      style: () => {
        return { width: "400px", textAlign: "right" };
      },
      hidden: Boolean(isMobile),
    },
    {
      dataField: "jir",
      text: translator("Report-View-TableHeader-Fiscal"),
      hidden: Boolean(isMobile),
      formatter: fiscalFormatter,
    },
  ];

  const exportToPdf = () => {
    let base64QR = document.getElementById("qrCode").toDataURL();
    convertToPdf.handlePrint(
      invoiceDetails,
      invoiceDetailsItems,
      invoiceDetailsPayments,
      invoiceDetailsTaxes,
      translator,
      base64QR
    );
  };

  const exportFunction = () => {
    var m = moment();
    var date = moment(startDate);
    m.set(date.toObject());
    reportService
      .invoicesList({
        tenantId: Number(search.tenantId),
        posId: search.posId,
        from: m.startOf("month").format(),
        to: m.endOf("month").format(),
        pageIndex: search.pageIndex,
        pageSize: 0,
      })
      .then((res) => {
        invoiceListServices.handlePrint(res.data.data, reportTag, translator);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const exportExcelFunction = () => {
    var m = moment();
    var date = moment(startDate);
    m.set(date.toObject());
    reportService
      .invoicesList({
        tenantId: Number(search.tenantId),
        posId: search.posId,
        from: m.startOf("month").format(),
        to: m.endOf("month").format(),
        pageIndex: search.pageIndex,
        pageSize: 0,
      })
      .then((res) => {
        // File name
        var ws_name = `${translator("InvoiceList-PDFTitle").slice(0, 25)}.xlsx`;
        // New work book
        var wb = XLSX.utils.book_new();
        const month = reportTag.date.getMonth() + 1;
        const year = reportTag.date.getFullYear();
        // Constant Data
        var ws_data = [
          [translator("InvIssReport-Filters-Tenants"), tenantObj.label],
          [translator("InvoiceCashBalancePDF-Date"), month + " / " + year],
          [
            translator("InvoiceListPdf-DocNum"),
            translator("InvoiceConclCashBalancePDF-Issued"),
            translator("InvoiceConclCashBalancePDF-Amount"),
          ],
        ];
        // Inconsistent data / Reports
        const ws_sufix = res.data.data.map((x) => {
          const array = [
            `${x.documentNumber}/${x.storeTag}/${x.posTag}`,
            dateTimeFormatter(x.issued),
            x.payValue,
          ];
          return array;
        });
        // Merge data
        ws_data = [...ws_data, ...ws_sufix];
        // Export to xlsx
        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        ws["!cols"] = [{ width: 13 }, { width: 22 }, { width: 15 }];
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
        XLSX.writeFile(wb, ws_name);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("InvListReport-Title")}</span>
        </div>

        <div className="card-body">
          <fieldset className="scheduler-border">
            <form className="row" onSubmit={handleSubmit(handleToSearch)}>
              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label htmlFor="ddlTenants">
                      {translator("InvIssReport-Filters-Tenants")}
                    </label>
                    <Controller
                      as={AsyncSelect}
                      control={control}
                      name="tenantId"
                      rules={{
                        validate: function (value) {
                          if (!value) return false;
                          return value.value === 0 ? false : true;
                        },
                      }}
                      onChange={function (event) {
                        setValue("storeTag", null);
                        setValue("posTag", null);
                        setTenantObj({
                          id: event[0].id,
                          label: event[0].label,
                          value: event[0].value,
                        });
                        setSearch({
                          ...search,
                          tenantId: event[0].id,
                        });
                        setReportTag({
                          ...reportTag,
                          tenantName: event[0].label,
                        });
                        getStores(event[0].id);
                        //setReports([]);

                        return event[0];
                      }}
                      defaultOptions={true}
                      loadOptions={promiseOptions}
                      placeholder={translator("Select-Tenant")}
                      value={tenantObj}
                    />
                    {errors.tenantId && errors.tenantId.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label>{translator("InvIssReport-Filters-StoreTag")}</label>{" "}
                    <Tooltip text={translator("StoreTagTooltip-Msg")} />
                    <Controller
                      as={Select}
                      control={control}
                      autoComplete="off"
                      name="storeTag"
                      placeholder={translator("SelectStoreTag")}
                      onChange={function (event) {
                        setValue("posTag", null);
                        setSearch({
                          ...search,
                          storeTag: event[0].value,
                        });
                        setReportTag({
                          ...reportTag,
                          storeName: event[0].label,
                        });
                        getPos(event[0].id);
                        //setReports([]);

                        return event[0];
                      }}
                      options={
                        storesTag &&
                        storesTag.map((e) => ({
                          id: e.id,
                          label: e.tag,
                          value: e.name,
                        }))
                      }
                    />
                    {errors.storeTag && (
                      <>
                        {errors.storeTag.type === "maxLength" && (
                          <p className="text-danger">
                            {translator(
                              "ValidationMsg-MaxLength-FiveCharacters"
                            )}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label>{translator("InvIssReport-Filters-PosTag")}</label>{" "}
                    <Tooltip text={translator("PosTagTooltip-Msg")} />
                    <Controller
                      as={Select}
                      control={control}
                      autoComplete="off"
                      placeholder={translator("SelectStoreTag")}
                      name="posTag"
                      onChange={function (event) {
                        setSearch({
                          ...search,
                          posId: event[0].id,
                        });
                        setReportTag({
                          ...reportTag,
                          posName: event[0].label,
                        });
                        //setReports([]);
                        return event[0];
                      }}
                      options={
                        posTag &&
                        posTag.map((e) => ({
                          id: e.posid,
                          label: e.tag + " - ( " + e.inventoryNumber+" )",
                          value: e.tag,
                        }))
                      }
                    />
                    {errors.posTag && (
                      <>
                        {errors.posTag.type === "maxLength" && (
                          <p className="text-danger">
                            {translator(
                              "ValidationMsg-MaxLength-FiveCharacters"
                            )}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </>
              }

              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label>{translator("InvIssReport-Month")}</label>
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <img src={iconcontentcalendar} alt="calendar" />
                        </span>
                      </div>
                      <Controller
                        as={DatePicker}
                        control={control}
                        autoComplete="off"
                        className="form-control"
                        selected={startDate}
                        valueName="selected"
                        name="from"
                        rules={{ required: true }}
                        locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                        onChange={function ([selected]) {
                          setStartDate(selected);
                          handleInputChange({
                            target: {
                              name: "from",
                              value: selected,
                            },
                          });
                          setReportTag({
                            ...reportTag,
                            date: selected,
                          });
                          //setReports([]);
                          return selected;
                        }}
                        dateFormat="MM/yyyy"
                        showMonthYearPicker
                      />
                      {errors.from && errors.from.type === "required" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-RequiredField")}
                        </p>
                      )}
                    </div>
                  </div>
                </>
              }

              {
                <>
                  <div
                    style={{ marginTop: "-28px" }}
                    className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12"
                  >
                    <label>{""}</label>
                    <div className="form-group">
                      <button
                        className="btn btn-primary pull-left mt-2"
                        type="submit"
                      >
                        <span className="icon icon-search"></span>{" "}
                        {translator("InvIssReport-Btn-Search")}
                      </button>
                    </div>
                  </div>
                </>
              }
            </form>
          </fieldset>

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={reports}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
            />
          )}

          {reports.length !== 0 ? (
            <>
              <button
                className="btn btn-outline-secondary"
                onClick={exportFunction}
              >
                <i className="fas fa-file-pdf"></i>{" "}
                {translator("Reports-PrintBtn")}
              </button>
              {"  "}
              <button
                className="btn btn-outline-secondary"
                onClick={exportExcelFunction}
              >
                <i className="fas fa-file-alt"></i>{" "}
                {translator("Reports-PrintExclBtn")}
              </button>
            </>
          ) : (
            ""
          )}

          <Modal
            scrollable={true}
            show={showInvoiceDetails}
            onHide={() => setShowInvoiceDetails(false)}
            //backdrop="static"
            keyboard={true}
            centered
          >
            <Modal.Header>
              <Modal.Title>{translator("Reports-InvoiceDetails")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div
                style={{
                  textAlign: "left",
                  fontSize: "15px",
                }}
              >
                <strong>
                  {" "}
                  <span style={{ fontSize: 19 }}>
                    {invoiceDetails.tenantName}
                  </span>
                </strong>
                <br />
                <br />
                {invoiceDetails.address}
                <br />
                {invoiceDetails.tenantCity}
                <br />
                OIB: {invoiceDetails.tenantOib}
                <hr style={{ border: "1px dashed lightgrey" }} />
                {invoiceDetails.storeName}
                <br />
                {invoiceDetails.storeAddress}
                <br />
                {invoiceDetails.storeCity &&
                  invoiceDetails.storeCity.replace(/,/g, ", ")}
              </div>
              {invoiceDetails.partnerGuid && (
                <>
                  <hr style={{ border: "1px dashed lightgrey" }} />
                  {"Partner:"}
                  <br />
                  {invoiceDetails.partnerName}
                  <br />
                  OIB: {invoiceDetails.partnerOib}
                  <br />
                  {invoiceDetails.partnerAddress}
                  <br />
                  {invoiceDetails.partnerCity}
                  <br />
                </>
              )}
              <hr style={{ border: "1px dashed lightgrey" }} />
              <span>
                <span style={{ textAlign: "left" }}>Datum računa:</span>
                <span style={{ float: "right" }}>
                  {invoiceDetails.issued &&
                    new Intl.DateTimeFormat("hr", {
                      year: "numeric",
                      month: "numeric",
                      day: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                      second: "numeric",
                      hour12: false,
                      timeZone: "Europe/Zagreb",
                    })
                      .format(new Date(invoiceDetails.issued))
                      .replace(/\s/g, "")
                      .substr(0, 10)}
                </span>
              </span>
              <br />
              <span>
                <span style={{ textAlign: "left" }}>Vrijeme izdavanja:</span>
                <span style={{ float: "right" }}>
                  {invoiceDetails.issued &&
                    new Intl.DateTimeFormat("hr", {
                      year: "numeric",
                      month: "numeric",
                      day: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                      second: "numeric",
                      hour12: false,
                      timeZone: "Europe/Zagreb",
                    })
                      .format(new Date(invoiceDetails.issued))
                      .replace(/\s/g, "")
                      .substr(11, 19)}
                </span>
              </span>
              <br />
              <span>
                <span style={{ textAlign: "left" }}>Način plaćanja:</span>
                <span style={{ float: "right" }}>
                  {invoiceDetailsPayments &&
                    invoiceDetailsPayments.reduce(function (a, b) {
                      return Number(a) + Number(b.paidValue);
                    }, 0) > 0 ? (
                    invoiceDetailsPayments.filter(
                      (e) => Number(e.paidValue) > 0
                    )[0].paymentMethodName
                  ) : (
                    <> <span> {invoiceDetails.paymentMethodName}</span> / <span style={{ color: "red" }}>Storno</span></>
                  )}
                </span>
              </span>
              <br />
              <span>
                <span style={{ textAlign: "left" }}>Operater:</span>
                <span style={{ float: "right" }}>
                  {invoiceDetails.userPrintName}
                </span>
              </span>
              <br />
              <br />
              <span style={{ fontSize: 19 }}>
                {" "}
                <span style={{ textAlign: "left" }}>
                  Račun: {invoiceDetails.documentNumber}/{""}
                  {invoiceDetails.storeTag}/{invoiceDetails.posTag}
                </span>
              </span>
              <br />
              <hr style={{ border: "1px dashed lightgrey" }} />
              <table style={{ width: "100%", fontSize: "16px" }}>
                <thead>
                  <tr>
                    <th>Naziv</th>
                    <th>Cijena</th>
                    <th>Kol.</th>
                    <th style={{ float: "right" }}>Iznos</th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceDetailsItems &&
                    invoiceDetailsItems.map((item) => {
                      return (
                        <>
                          <tr>
                            <td>{item.productName}</td>
                            <td>
                              {new Intl.NumberFormat("hr-HR", {
                                minimumFractionDigits: 2,
                              }).format(item.price)}
                            </td>
                            <td>
                              {item.quantity} {item.unitOfMeasureName}
                            </td>
                            <td style={{ float: "right" }}>
                              {new Intl.NumberFormat("hr-HR", {
                                minimumFractionDigits: 2,
                              }).format(item.totalValue)}
                            </td>
                          </tr>
                          {item.discount > 0 ? (
                            <tr>
                              <td></td>
                              <td>popust:</td>
                              <td>{item.discount}%</td>
                              <td style={{ float: "right" }}>
                                {new Intl.NumberFormat("hr-HR", {
                                  minimumFractionDigits: 2,
                                }).format(item.discountValue)}
                              </td>
                            </tr>
                          ) : null}
                        </>
                      );
                    })}
                </tbody>
              </table>
              <hr style={{ border: "1px dashed lightgrey" }} />
              <>
                {invoiceDetailsItems.reduce(function (a, b) {
                  return Number(a) + Number(b.discountValue);
                }, 0) > 0 ? (
                  <>
                    <span style={{ float: "left" }}>Ukupno : </span>{" "}
                    <span style={{ float: "right" }}>
                      {invoiceDetailsItems &&
                        currencyFormatter(
                          invoiceDetailsItems.reduce(function (a, b) {
                            return Number(a) + Number(b.totalValue);
                          }, 0),
                          null
                        )}
                    </span>
                    <br />
                    <span style={{ float: "left" }}>Popust : </span>{" "}
                    <span style={{ float: "right" }}>
                      {invoiceDetailsItems &&
                        currencyFormatter(
                          invoiceDetailsItems.reduce(function (a, b) {
                            return Number(a) + Number(b.discountValue);
                          }, 0)
                        )}
                    </span>
                    <br />
                  </>
                ) : null}
              </>
              <span style={{ float: "left", marginTop: "10px" }}>
                ZA PLATITI:{" "}
              </span>{" "}
              <span
                style={{
                  float: "right",
                  marginTop: "10px",
                }}
              >
                {/* {invoiceDetailsPayments &&
                  currencyFormatter(
                    invoiceDetailsPayments.reduce(function (a, b) {
                      return Number(a) + Number(b.paidValue);
                    }, 0)
                  )} */}
                {invoiceDetails && currencyFormatter(invoiceDetails.payValue)}
              </span>
              <br />
              <hr style={{ border: "1px dashed lightgrey" }} />
              <table style={{ width: "100%", fontSize: "16px" }}>
                <thead>
                  <tr>
                    <th>Stopa(%)</th>
                    <th>Osnovica</th>
                    <th style={{ float: "right" }}>Iznos</th>
                  </tr>
                </thead>
                <tbody>
                  {invoiceDetailsTaxes &&
                    invoiceDetailsTaxes.map((item) => {
                      return (
                        <>
                          <tr>
                            <td>
                              {item.taxRateId != null ? "PDV" : "PP"} :{" "}
                              {item.taxRateId != null ? item.taxRate : item.pp}
                            </td>
                            <td>
                              {new Intl.NumberFormat("hr-HR", {
                                minimumFractionDigits: 2,
                              }).format(item.groupNetValue)}
                            </td>
                            <td style={{ float: "right" }}>
                              {item.taxRateId != null
                                ? new Intl.NumberFormat("hr-HR", {
                                  minimumFractionDigits: 2,
                                }).format(item.groupTaxValue)
                                : new Intl.NumberFormat("hr-HR", {
                                  minimumFractionDigits: 2,
                                }).format(item.groupPpvalue)}
                            </td>
                          </tr>
                        </>
                      );
                    })}
                </tbody>
              </table>
              <hr style={{ border: "1px dashed lightgrey" }} />
              {invoiceDetailsItems &&
                invoiceDetailsItems.reduce(function (a, b) {
                  return Number(a) + Number(b.pn) * b.quantity;
                }, 0) > 0 ? (
                <>
                  {" "}
                  <span style={{ textAlign: "left" }}>Povratna naknada :</span>
                  <span style={{ float: "right" }}>
                    {invoiceDetailsItems &&
                      currencyFormatter(
                        invoiceDetailsItems.reduce(function (a, b) {
                          return Number(a) + Number(b.pn) * b.quantity;
                        }, 0)
                      )}
                  </span>
                  <hr style={{ border: "1px dashed lightgrey" }} />
                </>
              ) : (
                ""
              )}
              <hr style={{ border: "1px dashed lightgrey" }} />
              <div
                style={{
                  textAlign: "left",
                  fontSize: "15px",
                  marginTop: "15px",
                }}
              >
                ZKI: {invoiceDetails.zki}
                <br />
                JIR: {invoiceDetails.jir}
                <br />
                {invoiceDetails.taxNote
                  ? `Porezna bilješka: ${invoiceDetails.taxNote}`
                  : ""}
              </div>
              <hr style={{ border: "1px dashed lightgrey" }} />
              {qrcodeText !== "" && (
                <div style={{ textAlign: "center" }}>
                  <QRCode id="qrCode" size={120} value={qrcodeText} />
                  <div>{invoiceDetails.footerNote}</div>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={exportToPdf}
              >
                <i className="fas fa-file-pdf"></i>{" "}
                {translator("Reports-PrintBtn")}
              </button>
              <button
                className="btn btn-outline-secondary"
                onClick={() => setShowInvoiceDetails(false)}
              >
                {translator("General-Close")}
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default Table;
